import type { FC, ReactNode } from 'react';
import React from 'react';
import type { StackProps } from '@mui/material';
import { Stack, Typography } from '@mui/material';
import { pxToRem } from '../utils/getFontValue';

interface TwoLineCellProps
  extends Omit<StackProps, 'children' | 'sx' | 'direction'> {
  primary: ReactNode;
  secondary?: ReactNode;
  align?: 'left' | 'right';
}

export const TwoLineCell: FC<TwoLineCellProps> = ({
  primary,
  secondary,
  align = 'left',
  ...stackProps
}) => (
  <Stack
    {...stackProps}
    sx={{
      alignItems: align === 'right' ? 'flex-end' : 'flex-start',
      minWidth: 0,
      // Lets `noWrap` content truncate.
      '& > *': { maxWidth: '100%' },
    }}
  >
    <div>{primary}</div>
    {secondary !== undefined && (
      <Typography
        variant="caption"
        component="span"
        sx={{ color: 'text.secondary', fontSize: pxToRem(13) }}
      >
        {secondary === null || secondary === '' ? '--' : secondary}
      </Typography>
    )}
  </Stack>
);
